import createIcon from '../../createIcon';

/**
 * @component @name RuleFolder
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNkgxMkwxMCA0SDRDMi45IDQgMi4wMSA0LjkgMi4wMSA2TDIgMThDMiAxOS4xIDIuOSAyMCA0IDIwSDIwQzIxLjEgMjAgMjIgMTkuMSAyMiAxOFY4QzIyIDYuOSAyMS4xIDYgMjAgNlpNNy44MyAxNkw1IDEzLjE3TDYuNDEgMTEuNzZMNy44MiAxMy4xN0wxMS4zNiA5LjYzTDEyLjc3IDExLjA0TDcuODMgMTZaTTE3LjQxIDEzTDE5IDE0LjU5TDE3LjU5IDE2TDE2IDE0LjQxTDE0LjQxIDE2TDEzIDE0LjU5TDE0LjU5IDEzTDEzIDExLjQxTDE0LjQxIDEwTDE2IDExLjU5TDE3LjU5IDEwTDE5IDExLjQxTDE3LjQxIDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RuleFolder = createIcon('RuleFolder', [
  [
    'path',
    {
      d: 'M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM7.83 16L5 13.17L6.41 11.76L7.82 13.17L11.36 9.63L12.77 11.04L7.83 16ZM17.41 13L19 14.59L17.59 16L16 14.41L14.41 16L13 14.59L14.59 13L13 11.41L14.41 10L16 11.59L17.59 10L19 11.41L17.41 13Z',
      key: 'l4tl9y',
    },
  ],
]);

export default RuleFolder;
